export default {
  back: 'Wróć do menu',
  menu: 'Menu',
};
